export default __webpack_public_path__ + "static/media/acc-enterprise.7d508520.svg";